import React, { useState, useEffect } from 'react';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';
import { Container, Row, Col } from 'react-bootstrap';
import Picture from '../Picture';

import ICropper from '../../interfaces/ICropper';

import type { Partners$key } from './__generated__/Partners.graphql';
import './Partners.sass';

interface Props {
	allPartnersList: IPartnerObje | null;
	partnersList: Partners$key | null;
	partnersTitle: string;
}

interface IPartnerObje {
	partners: IPartnerItems;
}
interface IPartnerItems {
	items: IPartnerChildren[];
}
interface IPartnerChildren {
	_children: IPartnerChildrenArray;
}

interface IPartnerChildrenArray {
	items: IPartner[];
}

interface IPartner {
	partnerSiteUrl: string;
	picture: ICropper;
	_name: string;
	_id: string;
}

function Partners(props: Props) {
	const [extraPartners, setEtraPartners] = useState<IPartner[]>([]);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const partnersListData: any = useFragment(
		graphql`
			fragment Partners on HomePublishedContent {
				partners {
					... on PartnerPublishedContent {
						partnerSiteUrl
						picture
						_name
						_id
					}
				}
			}
		`,
		props.partnersList
	);
	useEffect(() => {
		if (partnersListData.partners) {
			if (partnersListData.partners.length < 10) {
				const partnersNames = partnersListData.partners.map(
					(partner: IPartner) => partner._name
				);
				if (props?.allPartnersList && props.allPartnersList.partners) {
					const notDuplicatedPartners = props.allPartnersList.partners.items[0]._children.items.filter(
						(partner: IPartner) => !partnersNames.includes(partner._name)
					);
					setEtraPartners(
						notDuplicatedPartners.slice(
							0,
							10 - partnersListData.partners.length
						)
					);
				}
			}
		} else {
			setEtraPartners(
				props?.allPartnersList && props.allPartnersList.partners
					? props.allPartnersList.partners.items[0]._children.items.slice(0, 10)
					: []
			);
		}
	}, [partnersListData, props.allPartnersList]);

	return (
		<div className="partners">
			<Container>
				<Row>
					<Col xs={12} className="partners__heading">
						<h2 className="uikit-label-small-caps">{props.partnersTitle}</h2>
					</Col>
				</Row>
				<Row>
					<Col xs={12} className="partners__list">
						{partnersListData.partners &&
							partnersListData.partners.map((partner: IPartner, index: number) => (
								index < 10
								? 
								<div className="partners__item" key={partner._id}>
									<Picture imageObj={partner.picture} />
								</div>
								: null
							))}
						{extraPartners.map((partner: IPartner) => (
							<div className="partners__item" key={partner._id}>
								<Picture imageObj={partner.picture} />
							</div>
						))}
					</Col>
				</Row>
			</Container>
		</div>
	);
}

export default Partners;
